import { motion } from "framer-motion";
import React from "react";

export const AnimateMotion = ({ children, ...rest }: React.ComponentProps<typeof motion.div>) => {
    return (
        <motion.div
            initial={{ opacity: 0, x: 30 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -30 }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
            {...rest}
        >
            {children}
        </motion.div>
    );
};
